import { render, staticRenderFns } from "./PreviewJobCompanyDetailOthers.vue?vue&type=template&id=70b1ae9e&scoped=true"
import script from "./PreviewJobCompanyDetailOthers.vue?vue&type=script&lang=js"
export * from "./PreviewJobCompanyDetailOthers.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobCompanyDetailOthers.vue?vue&type=style&index=0&id=70b1ae9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1ae9e",
  null
  
)

export default component.exports